import React from 'react';
import {EconomicIcon, QuickbooksIcon, SIZE, XeroIcon} from '@/web-components';
import {INVOICE_INTEGRATIONS} from './InvoiceIntegrationsUtils';

type InvoicingIntegrationIconProps = {
	integration: string | undefined;
	size?: SIZE.SMALL | SIZE.TAB | SIZE.DROPDOWN;
};

const InvoicingIntegrationIcon = ({integration, size}: InvoicingIntegrationIconProps): JSX.Element | null => {
	switch (integration) {
		case INVOICE_INTEGRATIONS.XERO:
			return <XeroIcon size={size || SIZE.DROPDOWN} />;
		case INVOICE_INTEGRATIONS.ECONOMIC:
			return <EconomicIcon size={size || SIZE.DROPDOWN} />;
		case INVOICE_INTEGRATIONS.QUICKBOOKS:
			return <QuickbooksIcon size={size || SIZE.DROPDOWN} />;
		default:
			return null;
	}
};

export default InvoicingIntegrationIcon;
